import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import EmptyOption from '../components/address/EmptyOption';
import Field2 from './Field2';
import FieldWrapper from './FieldWrapper/FieldWrapper';
import useStyles from './SelectField.styles';

function SelectField(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const options = props.definedField.options.map((option, index) => (
    <option value={option.value} key={index + 1}>
      {option.content}
    </option>
  ));
  options.unshift(<EmptyOption key="{0}" />);
  return (
    <Field2
      disabled={props.disabled}
      fieldContainer={props.fieldContainer}
      definedField={props.definedField}
      value={props.value}
      validationCallback={props.validationCallback}
      onChange={props.onChange}
      onBlur={props.onBlur}
    >
      {(onChange, onBlur, onFocus, errorText) => (
        <FieldWrapper
          label={props.definedField.label}
          required={props.definedField.required}
          link={props.definedField.link}
          toolTip={props.definedField.toolTip}
          htmlFor={props.legacyNames.id}
          wrappedClassName={props.legacyNames.wrappedClassName}
          errorText={errorText}
        >
          <select
            disabled={props.disabled}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            value={props.value || ''}
            id={props.legacyNames.id}
            name={props.legacyNames.nameOnForm}
            className={`${classes.selectField} select ${props.legacyNames.nameInClass} ${errorText ? 'error-block-v2' : ''}`}
            required={props.definedField.required && true}
          >
            {options}
          </select>
        </FieldWrapper>
      )}
    </Field2>
  );
}

SelectField.propTypes = {
  definedField: PropTypes.object.isRequired,
  fieldContainer: PropTypes.object.isRequired,
  fieldNamePrefix: PropTypes.string.isRequired,
  validationCallback: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  
  // optional
  legacyNames: PropTypes.object,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

export default SelectField;
